import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import TabularReportModel from "../../models/tabular-report";

export default class TabularReportRepository extends BaseRepository {
  static modelClass = TabularReportModel;
  modelName = "tabular-report";

  async findRecord(reportId, params) {
    const queryString = params ? "?" + qs.stringify(params) : "";
    return await super.findRecord("_", {
      urlPath: `tabular_reports/${reportId}/` + queryString,
    });
  }
  async run(reportId, params) {
    const normalized = Object.fromEntries(params.entries());
    const queryString = params ? "?" + qs.stringify(normalized) : "";
    return await super.findRecord("_", {
      urlPath: `tabular_reports/${reportId}/run/` + queryString,
    });
  }

  async export(reportId, params) {
    const queryString = params ? "?" + qs.stringify(params) : "";
    return await super.query({
      urlPath: `tabular_reports/${reportId}/export/` + queryString,
    });
  }
}
